import { ApiResponse } from "../types/common";
import apiClient from "./apiClient";

export interface ExchangeRate {
  id: string;
  sellValue: number; // USD to TJS conversion rate
  buyValue: number; // TJS to USD conversion rate (optional, for reference)
  isActive: boolean;
  comment: string;
  createdAt: string;
  updatedAt: string | null;
}

/**
 * Fetches the active USD to TJS exchange rate from our API
 * @returns Exchange rate data or null if fetch fails
 */
export const getExchangeRate = async (): Promise<ExchangeRate | null> => {
  try {
    const response = await apiClient.get<ApiResponse<ExchangeRate>>(
      "/Payment/active-exchange-rate"
    );

    if (response.data && response.data.data) {
      return response.data.data;
    }

    return null;
  } catch (error) {
    console.error("Failed to fetch exchange rate:", error);
    return null;
  }
};

/**
 * Converts USD amount to TJS (Somoni) using the sellValue from exchange rate
 * @param usdAmount - Amount in USD
 * @param exchangeRate - Exchange rate data
 * @returns Amount in TJS (Somoni)
 */
export const convertUsdToTjs = (
  usdAmount: number,
  exchangeRate: ExchangeRate | null
): number | null => {
  if (!exchangeRate || !exchangeRate.sellValue) {
    return null;
  }

  const sellValue = exchangeRate.sellValue;
  if (isNaN(sellValue) || sellValue <= 0) {
    return null;
  }

  return usdAmount * sellValue;
};
